"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BuildingsSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var BuildingsSVG = function BuildingsSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M26.72,6.82,14.36,2.07a1,1,0,0,0-.93.11A1,1,0,0,0,13,3v9H6a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V8.69A2,2,0,0,0,26.72,6.82ZM12,26H9a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Zm0-4H9a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Zm8,7a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Zm4,0a1,1,0,0,1-2,0V12a1,1,0,0,1,2,0Z"
  }));
};
exports.BuildingsSVG = BuildingsSVG;
BuildingsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BuildingsSVG);
exports.default = _default;